export const AppConfig = {
    center: [46.942464, 19.332677],
    zoom: 7,
    activeLayer: "allum_project:settlements_1910",
    colorRamp: "custom",
    colorRamps: {
        "custom": {
            name: "custom",
            colors: ["#ffffff", "#ffffff"]
        },
        "WhiteBlack": {
            name: "WhiteBlack",
            colors: ["#ffffff", "#000000"]
        },
        "WhiteRed": {
            name: "WhiteRed",
            colors: ["#ffffff", "#ff0000"]
        },
        "terrain": {
            name: "terrain",
            colors: ["#11FFA5", "#23FF00", "#F2F910", "#F9A810", "#553905"]
        },
        "colrampgrid": {
            name: "colrampgrid",
            colors: ["#2892C6", "#6CA9B3", "#9FC29A", "#CFDF7E", "#FAFB61", "#FBC15C", "#FA8C36", "#F7561F", "#FF0000", "#A70003"]
        },
        "colramp05": {
            name: "colramp05",
            colors: ["#2892C6","#80B4A8","#BFD38B","#F8F865","#FCB344","#F66D2F","#A80000"]
        },
        "colramp12": {
            name: "colramp12",
            colors: ["#006300","#538E17","#A5C30A","#FFFE03","#FFBA09","#FF7500","#E50007"]
        },
        "colramp13": {
            name: "colramp13",
            colors: ["#00B089","#80B3AD","#BCD185","#F9FA69","#F9AF44","#F86F1F","#EA1214"]
        },
        "colramp06": {
            name: "colramp06",
            colors: ["#E70000","#FB6D26","#FFB241","#FBFA60","#C0D387","#83B2AA","#2592CD"]
        },
        "colramp07": {
            name: "colramp07",
            colors: ["#F1F1A2","#FFFD38","#FC8100","#F505A6","#8B14E0","#0D1CAE"]
        },
        "colramp08": {
            name: "colramp08",
            colors: ["#FDFF79","#A1F24B","#36E108","#3FB768","#1B93AC","#204B90","#0E1075"]
        },
        "colramp09": {
            name: "colramp09",
            colors: ["#FFFFBD","#FFFF01","#FED47F","#F2A82F","#C56D19","#963A0B","#000000"]
        },
        "colramp10": {
            name: "colramp10",
            colors: ["#FFFFFF","#849EBC","#C0CABE","#FFFE70","#FFD47A","#FD5601","#D6311F","#B63200"]
        },
        "colramp11": {
            name: "colramp11",
            colors: ["#FFFFFF","#66B9FE","#65FFE1","#A2FF78","#FDFF02","#FBCC8C","#F69572","#EF0000","#AC0006"]
        },
        "colramp14": {
            name: "colramp14",
            colors: ["#FFFFFF","#86B1A9","#BFCE93","#F9F96E","#FFAC4E","#EE7132","#EF1301"]
        },
        "colramp15": {
            name: "colramp15",
            colors: ["#FFFFFF","#FC0100","#FF9C3D","#FED967","#FFFA06","#AACA91","#6BADAC","#0084AD"]
        }
    },
    activeField: "c_10200",
    styleData: {colorRamp: ["#000000", "#ffffff"], breaks:[]},
    layerOptions: [
        {
            name: "Settlements 1720-1785",
            layerId: "allum_project:settlements_1785"
        },
        {
            name: "Settlements 1865-1910",
            layerId: "allum_project:settlements_1910"
        },
        {
            name: "Settlements 2001-2011",
            layerId: "allum_project:settlements_2018"
        },
        {
            layerId: "allum_project:1720_1334_kulonbseg",
            name: "1720 / 1334 difference"
        },
        {
            layerId: "allum_project:1750er_1720er_kulonbseg",
            name: "1750 / 1720 Transylvania difference"
        },
        {
            layerId: "allum_project:1786_1334_kulonbseg",
            name: "1786 / 1334 difference"
        },
        {
            layerId: "allum_project:1786_1720_kulonbseg",
            name: "1786 / 1720 difference"
        },
        {
            layerId: "allum_project:1910_1334_kulonbseg",
            name: "1910 / 1334 difference"
        },
        {
            layerId: "allum_project:1910_1720_kulonbseg",
            name: "1910 / 1720 difference"
        },
        {
            layerId: "allum_project:1910_1750_kulonbseg",
            name: "1910 / 1750 difference"
        },
        {
            layerId: "allum_project:1910_1786_kulonbseg",
            name: "1910 / 1786 difference"
        },
        {
            layerId: "allum_project:1334_egesz_grid_sf",
            name: "1334 full grid sf"
        },
        {
            layerId: "allum_project:1334_erdelynelkul_grid_sf",
            name: "1334 without Transylvania grid sf"
        },
        {
            layerId: "allum_project:1720_10km_egesz_grid_sf",
            name: "1720 10km full grid sf"
        },
        {
            layerId: "allum_project:1720_egesz_grid_sf",
            name: "1720 full grid sf"
        },
        {
            layerId: "allum_project:1720_erdely_grid_sf",
            name: "1720 Transylvania grid sf"
        },
        {
            layerId: "allum_project:1720_erdelynelkul_grid_sf",
            name: "1720 without Transylvania grid sf"
        },
        {
            layerId: "allum_project:1720_erdelynelkul_grid_sf_kek",
            name: "1720 without Transylvania grid sf kek"
        },
        {
            layerId: "allum_project:1750_csakerdely_grid_sf",
            name: "1750 only Transylvania grid sf"
        },
        {
            layerId: "allum_project:1786_erdelynelkul_grid_sf",
            name: "1786 without Transylvania grid sf"
        },
        {
            layerId: "allum_project:1910_egesz_grid_sf",
            name: "1910 full grid sf"
        },
        {
            layerId: "allum_project:1910_egesz_grid_sn",
            name: "1910 full grid sn"
        },
        {
            layerId: "allum_project:1910_erdely_grid_sf",
            name: "1910 Transylvania grid sf"
        },
        {
            layerId: "allum_project:1910_erdely_nelkul_grid_sf",
            name: "1910 without Transylvania grid sf"
        },
        {
            layerId: "allum_project:2010_egesz_grid_sf",
            name: "2010 full grid sf"
        },
        {
            layerId: "allum_project:2010_erdely_grid_sf",
            name: "2010 Transylvania grid sf"
        },
        {
            layerId: "allum_project:2010_erdely_nelkul_grid_sf",
            name: "2010 without Transylvania grid sf"
        }
    ],
    layers: {
        'allum_project:settlements_1785': {
            type: 'WMS',
            id: 'allum_project:settlements_1785',
            active: true,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Settlements 1785',
            sortOrder: 3,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "c_s24000",
                "c_s23202",
                "c_s23203",
                "c_s21800",
                "c_s21900",
                "c_s23301",
                "c_s31300",
                "c_s31350",
                "c_s31400",
                "c_s31500",
                "c_s23201",
                "c_s23800",
                "c_s23900",
                "c_s23901",
                "c_s24302",
                //"c_s24303",
                "c_s24304",
                "c_s21600",
                "c_s21500",
                "c_s31100",
                "c_s31150",
                "c_s32000",
                "c_s32100",
                "c_s32200",
                "c_s24050",
                "c_s24060",
                "c_s24300",
                "c_s24400",
                "c_s24301",
                "c_s31000",
                "c_s21700",
                "c_s24100",
                "c_s24200",
                "c_s22900",
                "c_s20996",
                "c_s20997",
                "c_s21000",
                "c_s21001",
                "c_s21100",
                "c_s21200",
                "c_s21300",
                "c_s21400",
                "c_s21410",
                "c_s21411",
                "c_s21420",
                "c_s21430",
                "c_s21440",
                "c_s32400",
                "c_s32600",
                "c_s31900",
                "c_s31950",
                "c_s31960",
                "c_s23400",
                "c_s23500",
                "c_s23600",
                "c_s23700",
                "c_s31200",
                "c_s20990",
                "c_s21450",
                "c_s21460",
                "c_s31600",
                "c_s31700",
                "c_s31800",
                "c_s23100",
                "c_s32300",
                "c_s32500",
                "c_s23000"
            ],
            fieldStyles: {
                "range": [
                    "c_s20996",
                    "c_s20997",
                    "c_s21000",
                    "c_s21001",
                    "c_s21100",
                    "c_s21200",
                    "c_s21300",
                    "c_s21400",
                    "c_s21410",
                    "c_s21411",
                    "c_s21420",
                    "c_s21430",
                    "c_s21440",
                    "c_s21500",
                    "c_s21600",
                    "c_s21700",
                    "c_s21900",
                    //"c_s22900",
                    "c_s23000",
                    "c_s23100",
                    "c_s23201",
                    "c_s23202",
                    "c_s23203",
                    "c_s23301",
                    "c_s23800",
                    "c_s23900",
                    "c_s23901",
                    "c_s24000",
                    "c_s24050",
                    "c_s24060",
                    "c_s24100",
                    "c_s24200",
                    "c_s24300",
                    "c_s24301",
                    "c_s24302",
                    //"c_s24303",
                    "c_s24304",
                    "c_s24400",
                    "c_s31000",
                    "c_s31100",
                    "c_s31150",
                    "c_s31200",
                    "c_s31300",
                    "c_s31350",
                    "c_s31400",
                    "c_s31500",
                    "c_s31600",
                    "c_s31700",
                    "c_s31800",
                    "c_s31900",
                    "c_s31950",
                    "c_s31960",
                    "c_s32000",
                    "c_s32100",
                    "c_s32200",
                    "c_s32300",
                    "c_s32400",
                    "c_s32500",
                    "c_s32600"
                ],
                "categorical": [
                    "c_s20990",
                    "c_s21450",
                    "c_s21460",
                    "c_s21800",
                    "c_s22900",
                    "c_s23400",
                    "c_s23500",
                    "c_s23600",
                    "c_s23700"
                ]
            },
            sldBody: null
        },
        'allum_project:settlements_1910': {
            type: 'WMS',
            id: 'allum_project:settlements_1910',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Settlements 1910',
            sortOrder: 2,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "c_s9301",
                "c_s9700",
                "c_s9900",
                "c_s10000",
                "c_s10200",
                "c_s10600",
                "c_s10750",
                "c_s10800",
                "c_s11000",
                "c_s10700",
                "c_s10751",
                "c_s10900",
                "c_s10901",
                "c_s11100",
                "c_s11200",
                "c_s10701",
                "c_s14900",
                "c_s14901",
                "c_s15000",
                "c_s15001",
                "c_s15700",
                "c_s15801",
                "c_s14600",
                "c_s14700",
                "c_s15100",
                "c_s15200",
                "c_s15350",
                "c_s15400",
                "c_s15500",
                "c_s15600",
                "c_s15800",
                "c_s15250",
                "c_s15300",
                "c_s8700",
                "c_s8800",
                "c_s8801",
                "c_s8802",
                "c_s8900",
                "c_s9000",
                "c_s9100",
                "c_s9200",
                "c_s9300",
                "c_s9400",
                "c_s9500",
                "c_s9600",
                "c_s9800",
                "c_s10100",
                "c_s10400",
                "c_s12800",
                "c_s12900",
                "c_s13000",
                "c_s13100",
                "c_s13200",
                "c_s13300",
                "c_s13400",
                "c_s13500",
                "c_s13600",
                "c_s13700",
                "c_s13800",
                "c_s13900",
                "c_s14000",
                "c_s14100",
                "c_s14200",
                "c_s14300",
                "c_s14400",
                "c_s14500",
                "c_s10301",
                "c_s900",
                "c_s2100",
                "c_s2300",
                "c_s1000",
                "c_s600",
                "c_s300",
                "c_s500",
                "c_s1100",
                "c_s1300",
                "c_s390",
                "c_s1900",
                "c_s2000",
                "c_s2200",
                "c_s1400",
                "c_s1500",
                "c_s1600",
                "c_s1700",
                "c_s100",
                "c_s400",
                "c_s700",
                "c_s800",
                "c_s1200",
                "c_s195",
                "c_s200",
                "c_s201",
                "c_s190",
                "c_s16100",
                "c_s16300",
                "c_s16200",
                "c_s16400",
                "c_s16201",
                "c_s16401",
                "c_s16600",
                "c_s16650",
                "c_s18500",
                "c_s18700",
                "c_s18750",
                "c_s18770",
                "c_s18800",
                "c_s16500",
                "c_s16601",
                "c_s16651",
                "c_s16700",
                "c_s16701",
                "c_s18900",
                "c_s19000",
                "c_s19001",
                "c_s3300",
                "c_s3500",
                "c_s3501",
                "c_s3600",
                "c_s3700",
                "c_s3800",
                "c_s3100",
                "c_s3200",
                "c_s3900",
                "c_s4000",
                "c_s2900",
                "c_s2905",
                "c_s2500",
                "c_s2600",
                "c_s2700",
                "c_s2800",
                "c_s4300",
                "c_s4500",
                "c_s4600",
                "c_s5",
                "c_s7",
                "c_s10",
                "c_s5600",
                "c_s5100",
                "c_s5300",
                "c_s5400",
                "c_s5450",
                "c_s5451",
                "c_s5500",
                "c_s5501",
                "c_s5550",
                "c_s5551",
                "c_s5700",
                "c_s6500",
                "c_s6600",
                "c_s6800",
                "c_s6900",
                "c_s7000",
                "c_s7100",
                "c_s7200",
                "c_s6700",
                "c_s6701",
                "c_s5200",
                "c_s7300",
                "c_s7400",
                "c_s7500",
                "c_s7600",
                "c_s7700",
                "c_s7750",
                "c_s7800",
                "c_s7900",
                "c_s8000",
                "c_s8100",
                "c_s7901b",
                "c_s7401",
                "c_s7402",
                "c_s7501",
                "c_s7502",
                "c_s7601",
                "c_s7701",
                "c_s7702",
                "c_s7751",
                "c_s7752",
                "c_s7801",
                "c_s7901",
                "c_s7902",
                "c_s7990",
                "c_s8001",
                "c_s8200",
                "c_s8300"
            ],
            fieldStyles: {
                "range": [
                    "c_s10",
                    "c_s100",
                    "c_s1000",
                    "c_s10000",
                    "c_s10100",
                    "c_s10200",
                    "c_s10301",
                    "c_s10400",
                    "c_s10600",
                    "c_s10700",
                    "c_s10701",
                    "c_s10750",
                    "c_s10751",
                    "c_s10800",
                    "c_s10900",
                    "c_s10901",
                    "c_s1100",
                    "c_s11000",
                    "c_s11100",
                    "c_s11200",
                    "c_s1200",
                    "c_s12800",
                    "c_s12900",
                    "c_s1300",
                    "c_s13000",
                    "c_s13100",
                    "c_s13200",
                    "c_s13300",
                    "c_s13400",
                    "c_s13500",
                    "c_s13600",
                    "c_s13700",
                    "c_s13800",
                    "c_s13900",
                    "c_s1400",
                    "c_s14000",
                    "c_s14100",
                    "c_s14200",
                    "c_s14300",
                    "c_s14400",
                    "c_s14500",
                    "c_s14600",
                    "c_s14700",
                    "c_s14900",
                    "c_s14901",
                    "c_s1500",
                    "c_s15000",
                    "c_s15001",
                    "c_s15100",
                    "c_s15200",
                    "c_s15250",
                    "c_s15300",
                    "c_s15350",
                    "c_s15400",
                    "c_s15500",
                    "c_s15600",
                    "c_s15700",
                    "c_s15800",
                    "c_s15801",
                    "c_s1600",
                    "c_s16100",
                    "c_s16200",
                    "c_s16201",
                    "c_s16300",
                    "c_s16400",
                    "c_s16401",
                    "c_s16500",
                    "c_s16600",
                    "c_s16601",
                    "c_s16650",
                    "c_s16651",
                    "c_s16700",
                    "c_s16701",
                    "c_s1700",
                    "c_s18500",
                    "c_s18700",
                    "c_s18750",
                    "c_s18770",
                    "c_s18800",
                    "c_s18900",
                    "c_s190",
                    "c_s1900",
                    "c_s19000",
                    "c_s19001",
                    "c_s195",
                    "c_s200",
                    "c_s2000",
                    "c_s201",
                    "c_s2100",
                    "c_s2200",
                    "c_s2300",
                    "c_s2500",
                    "c_s2600",
                    "c_s2700",
                    "c_s2800",
                    "c_s2900",
                    "c_s2905",
                    "c_s300",
                    "c_s3100",
                    "c_s3200",
                    "c_s3300",
                    "c_s3500",
                    "c_s3501",
                    "c_s3600",
                    "c_s3700",
                    "c_s3800",
                    "c_s390",
                    "c_s3900",
                    "c_s400",
                    "c_s4000",
                    "c_s4300",
                    "c_s4500",
                    "c_s4600",
                    "c_s5",
                    "c_s500",
                    "c_s5100",
                    "c_s5200",
                    "c_s5300",
                    "c_s5400",
                    "c_s5450",
                    "c_s5451",
                    "c_s5500",
                    "c_s5501",
                    "c_s5550",
                    "c_s5551",
                    "c_s5600",
                    "c_s5700",
                    "c_s600",
                    "c_s6500",
                    "c_s6600",
                    "c_s6700",
                    "c_s6701",
                    "c_s6800",
                    "c_s6900",
                    "c_s7",
                    "c_s700",
                    "c_s7000",
                    "c_s7100",
                    "c_s7200",
                    "c_s7300",
                    "c_s7400",
                    "c_s7401",
                    "c_s7402",
                    "c_s7500",
                    "c_s7501",
                    "c_s7502",
                    "c_s7600",
                    "c_s7601",
                    "c_s7700",
                    "c_s7701",
                    "c_s7702",
                    "c_s7750",
                    "c_s7751",
                    "c_s7752",
                    "c_s7800",
                    "c_s7801",
                    "c_s7900",
                    "c_s7901",
                    "c_s7901b",
                    "c_s7902",
                    "c_s7990",
                    "c_s800",
                    "c_s8000",
                    "c_s8001",
                    "c_s8100",
                    "c_s8200",
                    "c_s8300",
                    "c_s8700",
                    "c_s8800",
                    "c_s8801",
                    "c_s8802",
                    "c_s8900",
                    "c_s900",
                    "c_s9000",
                    "c_s9100",
                    "c_s9200",
                    "c_s9300",
                    "c_s9301",
                    "c_s9400",
                    "c_s9500",
                    "c_s9600",
                    "c_s9700",
                    "c_s9800",
                    "c_s9900"
                ]
            },
            sldBody: null
        },
        'allum_project:settlements_2018': {
            type: 'WMS',
            id: 'allum_project:settlements_2018',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Settlements 2018',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "c_s50001",
                "c_s50002",
                "c_s50003",
                "c_s50004",
                "c_s50005",
                "c_s50006",
                "c_s50007",
                "c_s50008",
                "c_s50009",
                "c_s50000",
                "c_s50010",
                "c_s50011"
            ],
            fieldStyles: {
                "range": [
                    "c_s50000",
                    "c_s50001",
                    "c_s50002",
                    "c_s50003",
                    "c_s50004",
                    "c_s50005",
                    "c_s50006",
                    "c_s50007",
                    "c_s50008",
                    "c_s50009",
                    "c_s50010",
                    "c_s50011"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_1334_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1720_1334_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_1334_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1750er_1720er_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1750er_1720er_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1750er_1720er_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1786_1334_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1786_1334_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1786_1334_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1786_1720_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1786_1720_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1786_1720_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_1334_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1910_1334_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_1334_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_1720_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1910_1720_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_1720_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_1750_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1910_1750_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_1750_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_1786_kulonbseg': {
            type: 'WMS',
            id: 'allum_project:1910_1786_kulonbseg',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_1786_kulonbseg',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1334_egesz_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1334_egesz_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1334_egesz_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1334_erdelynelkul_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1334_erdelynelkul_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1334_erdelynelkul_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_10km_egesz_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1720_10km_egesz_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_10km_egesz_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_egesz_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1720_egesz_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_egesz_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_erdely_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1720_erdely_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_erdely_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_erdelynelkul_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1720_erdelynelkul_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_erdelynelkul_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1720_erdelynelkul_grid_sf_kek': {
            type: 'WMS',
            id: 'allum_project:1720_erdelynelkul_grid_sf_kek',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1720_erdelynelkul_grid_sf_kek',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1750_csakerdely_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1750_csakerdely_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1750_csakerdely_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1786_erdelynelkul_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1786_erdelynelkul_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1786_erdelynelkul_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_egesz_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1910_egesz_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_egesz_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_egesz_grid_sn': {
            type: 'WMS',
            id: 'allum_project:1910_egesz_grid_sn',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_egesz_grid_sn',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_erdely_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1910_erdely_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_erdely_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:1910_erdely_nelkul_grid_sf': {
            type: 'WMS',
            id: 'allum_project:1910_erdely_nelkul_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '1910_erdely_nelkul_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:2010_egesz_grid_sf': {
            type: 'WMS',
            id: 'allum_project:2010_egesz_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '2010_egesz_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:2010_erdely_grid_sf': {
            type: 'WMS',
            id: 'allum_project:2010_erdely_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '2010_erdely_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        'allum_project:2010_erdely_nelkul_grid_sf': {
            type: 'WMS',
            id: 'allum_project:2010_erdely_nelkul_grid_sf',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: '2010_erdely_nelkul_grid_sf',
            sortOrder: 1,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "val"
            ],
            fieldStyles: {
                "categorical": [
                    "val"
                ]
            },
            sldBody: null
        },
        // 'base': {
        //     type: 'TILE',
        //     id: 'base',
        //     active: true,
        //     url: 'https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFuaS1udW1lcjgiLCJhIjoiY2t1bTd4Zmk5MGJ0ZjJ3cGk4azUwcGN1dCJ9.aZG8b4U6WwJygbDqSDriWQ',
        //     name: 'Streets - Base',
        //     sortOrder: -2,
        //     showLegend: false,
        //     showInLayerList: false
        // },
        'allum_project:basemap': {
            type: 'BASE',
            id: 'allum_project:allut_lines,allum_project:kozlut_lines,allum_project:megyeiut_lines,allum_project:vasutallomas,allum_project:vasutvonal,allum_project:kikoto,allum_project:folyokl,allum_project:jaras1912,allum_project:jarasgeo1912,allum_project:mo1912,allum_project:megye1912,allum_project:country_borders_2016,allum_project:megye1785,allum_project:folyokm,allum_project:tavak',
            active: true,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Basemap',
            sortOrder: 10,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            opacity: 0.9
        },
    },
    enabledBmaps: ["allum_project:allut_lines",
    "allum_project:kozlut_lines",
    "allum_project:megyeiut_lines",
    "allum_project:vasutvonal",
    "allum_project:folyokl",
    "allum_project:jaras1912",
    "allum_project:jarasgeo1912",
    "allum_project:mo1912",
    "allum_project:megye1912",
    "allum_project:country_borders_2016",
    "allum_project:folyokm",
    "allum_project:tavak",
    "allum_project:vasutallomas",
    "allum_project:kikoto"
]
}